import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { DRFlagV2, FRFlagV2, HTFlagV2, USFlagV2 } from "./FlagIcons";

interface LanguageSwitcherProps {
    onClose?: () => void;
    disabledLanguages?: string[];
}

const LanguageSwitcher: FunctionComponent<LanguageSwitcherProps> = ({ onClose, disabledLanguages = [] }) => {
    const { i18n, t } = useTranslation();

    const handleLanguageChange = (lng: string) => {
        i18n.changeLanguage(lng);
        onClose?.();
    };

    const languages = [
        { code: 'es', name: t('language.spanish'), label: 'ES', flag: DRFlagV2, country: 'Rep. Dominicana' },
        { code: 'en', name: t('language.english'), label: 'EN', flag: USFlagV2, country: 'USA' },
        { code: 'ht', name: t('language.creole') || 'Créole', label: 'HT', flag: HTFlagV2, country: 'Haití' },
        { code: 'fr', name: t('language.french'), label: 'FR', flag: FRFlagV2, country: 'Francia' }
    ];

    return (
        <div className="flex flex-col gap-2">
            <p className="text-sm font-semibold text-[#5E5D62] px-4 py-2">
                {t('language.select')}
            </p>
            {languages
                .filter(lang => !disabledLanguages.includes(lang.code))
                .map((lang) => {
                    const FlagComponent = lang.flag;
                    return (
                        <button
                            key={lang.code}
                            onClick={() => handleLanguageChange(lang.code)}
                            className={`flex items-center gap-3 px-4 py-2 text-left w-full ${
                                i18n.language === lang.code
                                    ? 'bg-[#0050DA] text-white'
                                    : 'hover:bg-gray-100 text-[#5E5D62]'
                            } transition-colors duration-200`}
                        >
                            <FlagComponent className="w-12 h-9 rounded-sm" />
                            <div className="flex-1">
                                <span className="block text-sm font-medium">{lang.name}</span>
                                <span className="text-xs opacity-75">{lang.country}</span>
                            </div>
                            {i18n.language === lang.code && (
                                <i className="d-icon d-check text-sm"></i>
                            )}
                        </button>
                    );
                })}
        </div>
    );
};

export default LanguageSwitcher;
